import { render, staticRenderFns } from "./CategoryConfiguratorDelivery.vue?vue&type=template&id=3d99afa5&"
import script from "./CategoryConfiguratorDelivery.vue?vue&type=script&lang=js&"
export * from "./CategoryConfiguratorDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports